const config = {
  API_BASE: process.env.REACT_APP_API_BASE,
  COGNITO_USER_POOL_ID: 'ap-south-1_AAm20iWm7',
  COGNITO_CLIENT_ID: '6kmis4nfr4c27hv5r5t18ah6lv'
};

export default config;